<template>
  <div class="app-container">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>用户活跃度详情导出</span>
      </div>
      <div class="filter-container">
        <el-form :model="query" ref="queryForm" :inline="true">
          <el-form-item label="用户ID：">
            <el-input v-model="query.userId" placeholder="请输入用户ID" clearable size="small" />
          </el-form-item>
          
          <el-form-item>
            <el-button type="primary" @click="handleExport" size="mini" :loading="exportLoading">导出</el-button>
            <el-button type="info" @click="handleFilter" plain size="mini">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
  </div>
</template>

<script>
import liveManageApi from '@/api/live/liveManage'

export default {
  name: 'UserActivityDetailExport',
  data() {
    return {
      exportLoading: false,
      query: {
        pageNo: 0,
        pageSize: 0,
        userId: 0
      }
    }
  },
  created() {
    // 从URL参数中获取userId
    if (this.$route.query.userId) {
      this.query.userId = parseInt(this.$route.query.userId)
    }
  },
  methods: {
    /**
     * 重置表单
     */
    handleFilter() {
      this.query = {
        pageNo: 0,
        pageSize: 0,
        userId: 0
      }
    },
    /**
     * 导出数据
     */
    handleExport() {
      if (!this.query.userId) {
        this.$message.warning('请输入用户ID')
        return
      }
      
      this.exportLoading = true
      
      // 准备导出参数
      const exportParams = {
        pageNo: 0,
        pageSize: 0,
        userId: parseInt(this.query.userId) || 0
      }
      
      console.log('导出参数:', exportParams)
      
      liveManageApi.downloadStatisticsByUserDetail(exportParams)
        .then(response => {
          console.log('导出响应:', response)
          this.$message.success('导出成功')
          // 这里可以处理文件下载
        })
        .catch(error => {
          console.error('导出失败:', error)
          this.$message.error('导出失败')
        })
        .finally(() => {
          this.exportLoading = false
        })
    }
  }
}
</script>

<style scoped>
.filter-container {
  padding: 20px;
}
</style>
